<div class="xl-content" style="flex: 1 1 auto;">
    <table #table class="table table-bordered m-0 text-center">
        <ng-container *ngIf="_data">
            <thead class="sticky-top">
            <tr>
                <th>Location</th>
                <th>Building type</th>
                <th>Energy label</th>
                <th class="notranslate">kWh/m<sup>2</sup></th>
                <th>Paris proof</th>
                <th>
                    <span>Area</span>
                    <span class="notranslate"> m<sup>2</sup></span>
                </th>
            </tr>
            </thead>
            <tbody class="overflow-auto">
                <ng-container *ngFor="let row of records(_data); index as i; trackBy : trackBy">
                    <tr>
                        <td class="text-start notranslate">{{row.locationName}}</td>
                        <td>{{row.buildingTypeName}}</td>
                        <td class="notranslate">{{row.energyLabel}}</td>
                        <td class="notranslate" [ngClass]="{'text-danger': row.value > row.parisProofValue, 'text-success': row.value < row.parisProofValue}">{{row.value}}</td>
                        <td class="notranslate">{{row.parisProofValue}}</td>
                        <td class="notranslate">{{row.area}}</td>
                    </tr>
                </ng-container>
            </tbody>
        </ng-container>
    </table>
</div>
